import React from 'react';
import { useSelector } from 'react-redux';
import getProductPreviews from 'store/product/selector/getProductPreviews';
import getForcedProductPreviews from 'store/product/selector/getForcedProductPreviews';
import styles from './ProductPreview.module.scss';

const ProductPreview = () => {
  const originalPreviews = useSelector(getProductPreviews);
  const forcedPreviews = useSelector(getForcedProductPreviews);

  const mixedPreviews = originalPreviews.map((preview, index) => forcedPreviews[index] || preview);
  const preview = mixedPreviews[0];

  return (
    <div className={styles.productPreview}>
      <img src={preview} alt="" />
    </div>
  );
};

export default ProductPreview;
